import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";

export const Route = createFileRoute("/_dash/ai-edits/evals")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PermissionGuard permission="evals:view">
      <Outlet />
    </PermissionGuard>
  );
}
